import { useContext, useEffect, useState } from 'react'
import { UIContext } from 'Context/UI'
import { useNavigate } from 'react-router-dom'

import Checkbox from 'Presentation/Components/Table/Cells/Checkbox'
import ColorfulAbbreviation from 'Presentation/Components/Table/Cells/ColorfulAbbreviation'
import DoubleLine from 'Presentation/Components/Table/Cells/DoubleLine'
import Switch from 'Presentation/Components/Table/Cells/Switch'

import { FILTERS } from '../Config'

const MOCK_DATA = [
	{
		checkbox: false,
		label: 'SGS',
		description: 'ใบการันตีคุณภาพวัถุดิบ',
		active: true,
		color: '#FA4F02',
	},
	{
		checkbox: false,
		label: 'Analysis test',
		description: 'ใบเช็คคุณภาพสินค้า',
		active: true,
		color: '#FCCC33',
	},
	{
		checkbox: false,
		label: 'Certification',
		description: 'ใบเซอร์การการันตีคุณภาพในการผลิตลอตนั้นๆ (ส่งพร้อมสินค้า)',
		active: true,
		color: '#FCCC33',
	},
	{
		checkbox: false,
		label: 'FSC 100%',
		description: 'ใบการันตีที่ทำจากวัสดุจากป่าที่ถูกต้องตามกฏหมาย',
		active: true,
		color: '#29CE72',
	},
	{
		checkbox: false,
		label: 'FSC Recycled',
		description: 'ใบการันตีที่ใช้วัสดุที่มาจากการรีไซเคิล 100%',
		active: true,
		color: '#FA4F02',
	},
	{
		checkbox: false,
		label: 'FSC Mix',
		description: 'ใบการันตีที่ทำจากวัสดุจากป่าที่ถูกต้องตามกฏหมายเเละมีส่วนผสมของการรีไซเคิล',
		active: true,
		color: '#29CE72',
	},
	{
		checkbox: false,
		label: 'SFI Chain of Custody',
		description:
			'ใบการันตีท่ีระบุว่าเยื่อกระดาษทำมาจากส่วนผสมของแหล่งที่ผ่านการรับรอง SFI เยื่อกระดาษรีไซเคิล และไม้จากป่าควบคุม',
		active: true,
		color: '#FCCC33',
	},
	{
		checkbox: false,
		label: 'Ships in Own Container (SIOC)',
		description: 'จัดส่งจากผู้ผลิตโดยตรง',
		active: true,
		color: '#29CE72',
	},
]

const ViewModel = () => {
	const { setCustomContentToolbar, setShowContentToolbar } = useContext(UIContext)
	const [filters] = useState(
		FILTERS.map(f => {
			if (f.label.toLowerCase() === 'certificates') {
				return {
					...f,
					isActive: true,
				}
			}

			return f
		})
	)
	const navigate = useNavigate()

	const onClickFilter = (idx: number) => {
		// Sustainability
		if (idx === 3) {
			navigate('/general/sustainability')
		}
		// Certification
		else if (idx === 4) {
			return
		} else {
			navigate('/general/production', { state: { filterIdx: idx } })
		}
	}

	const TABLE_CONFIGS: any = [
		{
			Header: () => <Checkbox value={false} />,
			accessor: 'checkbox',
			width: 25,
			minWidth: 25,
			disableSortBy: true,
			Cell: ({ value }: any) => <Checkbox value={value} />,
		},
		{
			Header: 'รหัส',
			accessor: 'abbreviation',
			width: 30,
			minWidth: 30,
			Cell: ({ row }: any) => (
				<ColorfulAbbreviation label={row.original.label} color={row.original.color} />
			),
		},
		{
			Header: 'ชื่อ',
			accessor: 'label',
			width: 450,
			minWidth: 450,
			Cell: ({ row }: any) => (
				<DoubleLine label={row.original.label} description={row.original.description} />
			),
		},
		{
			Header: 'ใช้งานอยู่',
			accessor: 'active',
			width: 100,
			minWidth: 100,
			Cell: ({ value }: any) => <Switch value={value} />,
		},
	]

	useEffect(() => {
		setShowContentToolbar(false)
		setCustomContentToolbar(null)

		return () => {
			setShowContentToolbar(true)
			setCustomContentToolbar(null)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return {
		filters,
		onClickFilter,
		data: MOCK_DATA,
		TABLE_CONFIGS,
	}
}

export default ViewModel
